
<v-card
  class="integration-create-card"
  :class="{ 'disabled-card': disabled }"
  outlined
  hover
  @click="handleClick"
>
  <div class="create-card-content">
    <!-- Icon -->
    <div class="create-icon-container">
      <v-icon
        :color="disabled ? 'grey' : 'primary'"
        size="48"
      >
        {{ disabled ? 'mdi-lock' : 'mdi-plus-circle' }}
      </v-icon>
    </div>      <!-- Content -->
    <div class="create-content">
      <!-- License Usage (when showUsage is true) -->
      <div v-if="showUsage" class="usage-info">
        <span class="usage-text">
          {{ currentUsage }} of {{ maxIntegrations }} integrations used
        </span>
        <v-progress-linear
          :value="usagePercentage"
          :color="usageColor"
          height="3"
          rounded
          class="usage-progress mt-1 mb-3"
        />
      </div>

      <h3 class="create-title">
        {{ disabled ? 'License Limit Reached' : 'Create New System' }}
      </h3>
      <p class="create-subtitle">
        {{ disabled ? 'Upgrade your license to add more integrations' : 'Connect a new integration to sync data automatically' }}
      </p>
    </div>

    <!-- Action Button -->
    <div class="create-action">
      <v-btn
        :disabled="disabled"
        :color="disabled ? 'grey' : 'primary'"
        :outlined="disabled"
        @click.stop="handleButtonClick"
      >
        {{ disabled ? 'Upgrade License' : 'Get Started' }}
      </v-btn>
    </div>
  </div>
</v-card>
